import { SelectOption } from '@/components/elements/select'

export const daysMap: SelectOption[] = [
	{ label: '7 Dias', value: '7' },
	{ label: '15 Dias', value: '15' },
	{ label: '30 Dias', value: '30' },
	{ label: '45 Dias', value: '45' },
	{ label: '60 Dias', value: '60' },
	{ label: '90 Dias', value: '90' },
	{ label: '364 Dias', value: '364' },
]
